
import { useDispatch, useSelector } from 'react-redux'
import { setCreatemodal, setLoader,setTechncian,setAssignTechnician,setRescheduleModal,setImageModal,setEditTechnician,setSlotPage,setPickupModal,setDropModal } from './page';
import { setList } from './requests';
import { setAddresslist, setAddressTypeList, setBikelist, setBikeType, setBranchList, setCityList, setOfferList, setServicePackage, setServiceRequiredList, setServiceType, setStateList, setSuperStarList ,setGearSystem,setBrand,setSlotDates,setSlotTime,setBranchDetail,setAvailableTechnicianData,setAvailableSlots} from './createRequestDetails';
import { clearCreateRequestData, setCreateRequestData } from './requestUser';
import { setData,setTracking } from './serviceDetail';
import { setBranchTechnician } from './branchDetail';

const Storelist = () => {

    const dispatch = useDispatch()


    const PageStore = useSelector((store)=> store.PageStore);
    const RequestsStore = useSelector((store)=> store.RequestsStore);
    const BranchDetailStore = useSelector((store)=> store.branchDetailStore);
    const CreateRequestDetailsStore = useSelector((store)=> store.CreateRequestDetailsStore);
    const RequestUserStore = useSelector((store)=> store.requestUserStore);
    const ServiceDetailsStore = useSelector((store)=> store.serviceDetailsStore);
    

    const setLoading=(value)=>dispatch(setLoader(value))
    const storeSlotData=(value)=>dispatch(setAvailableSlots(value))
    const setAddTechnician=(value)=>dispatch(setTechncian(value))
    const AssignTechnician=(value)=>dispatch(setAssignTechnician(value))
    const setCreatemodal_=(value)=>dispatch(setCreatemodal(value))
    const setRequestsList=(value)=>dispatch(setList(value))
    const setReschedule = (value) => dispatch(setRescheduleModal(value));
    const setImageViewer = (value) => dispatch(setImageModal(value));
    const editTechnician=(value)=>dispatch(setEditTechnician(value))
    const setSlotModal=(value)=>dispatch(setSlotPage())
    const pickUpModal = (value) => dispatch(setPickupModal());
    const dropModal = (value) => dispatch(setDropModal());
    // CREATE REQUEST DETAILS
    const setServiceType_=(value)=>dispatch(setServiceType(value))
    const setBranchDetail_=(value)=>dispatch(setBranchDetail(value))
    const setServicePackage_=(value)=>dispatch(setServicePackage(value))
    const setBikeType_=(value)=>dispatch(setBikeType(value))
    const setGearSystem_=(value)=>dispatch(setGearSystem(value))
    const setBikelist_=(value)=>dispatch(setBikelist(value))
    const setBrand_=(value)=>dispatch(setBrand(value))
    const setBranchList_=(value)=>dispatch(setBranchList(value))
    const setAddresslist_=(value)=>dispatch(setAddresslist(value))
    const setAddressTypeList_=(value)=>dispatch(setAddressTypeList(value))
    const setStateList_=(value)=>dispatch(setStateList(value))
    const setCityList_=(value)=>dispatch(setCityList(value))
    const setServiceRequiredList_=(value)=>dispatch(setServiceRequiredList(value))
    const setOfferList_=(value)=>dispatch(setOfferList(value))
    const setSuperStarList_=(value)=>dispatch(setSuperStarList(value))
    const setSlotDates_ = value=>dispatch(setSlotDates(value))
    const setAvailableTechnicianData_ = value => dispatch(setAvailableTechnicianData(value))
    // CREATE REQUEST DATA
    const setCreateRequestData_=(value)=>dispatch(setCreateRequestData(value))
    const clearCreateRequestData_=()=>dispatch(clearCreateRequestData())
    // SERVICE DETAILS
    const setServiceDetailsData_=(value)=>dispatch(setData(value))
    const setServiceTrackingData_=(value)=>dispatch(setTracking(value))
    const setslotTime_=(value)=>dispatch(setSlotTime(value))

    // BRANCH DETAILS
    const setBranchTechnician_ = (value) => dispatch(setBranchTechnician(value));

  return {
    PageStore,
    setLoading,
    setCreatemodal_,
    RequestsStore,
    setRequestsList,
    CreateRequestDetailsStore,
    setServiceType_,
    setServicePackage_,
    setBikeType_,
    setBikelist_,
    setBranchList_,
    setAddresslist_,
    setAddressTypeList_,
    setStateList_,
    setCityList_,
    setServiceRequiredList_,
    setOfferList_,
    setSuperStarList_,
    setSlotDates_,
    // CREATE REQUEST DATA
    RequestUserStore,
    setCreateRequestData_,
    clearCreateRequestData_,
    // SERVICE DETAILS
    ServiceDetailsStore,
    setServiceDetailsData_,
    setGearSystem_,
    setBrand_,
    setslotTime_,
    setServiceTrackingData_,
    setBranchDetail_,
    setBranchTechnician_,
    BranchDetailStore,
    setAddTechnician,
    AssignTechnician,
    setReschedule,
    setAvailableTechnicianData_,
    setImageViewer,
    editTechnician,
    setSlotModal,
    storeSlotData,
    dropModal,
    pickUpModal
  }
}

export default Storelist